import { useField } from "formik";
import { observer } from "mobx-react-lite";
import React from "react";
import { Form, Label, Select } from "semantic-ui-react";

interface Props {
  placeholder: string;
  name: string;
  options: any;
  label?: string;
}

const SelectInput = (props: Props) => {
  const [field, meta, helpers] = useField(props.name);
  return (
    <Form.Field error={meta.touched && !!meta.error}>
      <label>{props.label}</label>
      <Select
        search
        clearable
        options={props.options}
        value={field.value || null}
        onChange={(e, d) => helpers.setValue(d.value)}
        onBlur={() => helpers.setTouched(true)}
        placeholder={props.placeholder}
      ></Select>
      {meta.touched && meta.error ? (
        <Label basic color="red" pointing="above">
          {meta.error}
        </Label>
      ) : null}
    </Form.Field>
  );
};

export default observer(SelectInput);
